module.exports = __webpack_public_path__ + "static/DannyLi-a8940b08d1c718e061c77ba0f010b0f7.jpg";